import * as yup from "yup";
export var toggleableParamSchema = yup
    .object()
    .shape({
    isEnabled: yup.string().oneOf(["true", "false", "any"]),
})
    .snakeCase()
    .defined();
